import React, {useEffect} from 'react'
import {connect} from 'react-redux'
import {read} from '../HOC/Firebase/ReadHOC'
import Header from './Header'
import EditWall from './EditWall'
import FormEdit from './FormEdit'
import {edit} from './action_creators'
import {
  activateSection,
  activateField,
  readActions,
  readForm,
  readSections,
  readRubrics,
  readIcons,
  readRatings,
} from './effects'
import './Forms.css'

const stop = (state) => ({form: state.form, active: state.active})
const dtop = {edit}

export function TopLevelState({form, edit, active, match}) {
  const id = match.params.id

  useEffect(activateSection, [active.section])
  useEffect(activateField, [active.field])

  useEffect(readForm(id), [])
  useEffect(readSections(id, form.id), [form.id])
  useEffect(readActions(id, form.id), [form.id])
  useEffect(readRubrics(id), [])
  useEffect(readIcons(id), [])
  useEffect(readRatings(id), [])

  return (
    <div
      onClick={() => {
        edit(null)
      }}
      className="pageContainer"
    >
      <Header />
      <div>{form.active ? <EditWall /> : <FormEdit />}</div>
    </div>
  )
}

const WrappedFormEdit = read()(connect(stop, dtop)(TopLevelState))
export default WrappedFormEdit
